import { createUnknownErrorResult } from '@/entities/FetchResult'
import { FetchCollectionResult, FetchResult, FetchResultType } from '@/entities/FetchResult'
import { authorizedFetch } from '@/helpers/authorizedFetch'
import { reportError, reportMessage } from '@/helpers/errorReporting'
import { generateApiUrl } from '@/helpers/url'

import { ClockedInTrackResourceV3, ClockedInTrackV3 } from './Track'
import { transformToClockedInTrackV3 } from './TrackTransformers'

export const getClockedInTracksV3ApiCall = async (): Promise<FetchCollectionResult<ClockedInTrackV3[], string>> => {
    try {
        const url = generateApiUrl({
            endpoint: '/api/v3/tracks/clocked-in',
        })

        const response = await authorizedFetch(url)
        const doc: ClockedInTrackResourceV3[] = await response.json()

        if (! doc) {
            reportMessage('getClockedInTracksV3ApiCall', `getClockedInTracksV3ApiCall failed with status code ${response.status}`)

            return createUnknownErrorResult(response.status)
        }

        const tracks = doc.map(transformToClockedInTrackV3)

        return {
            amountOfPages: 1,
            status: response.status,
            type: FetchResultType.Success,
            data: tracks,
        }
    } catch (error) {
        reportError('getClockedInTracksV3ApiCall', error)

        return createUnknownErrorResult(500)
    }
}

export const getTrackDivergence = async (trackId: string): Promise<FetchResult<boolean, string>> => {
    try {
        const url = generateApiUrl({
            endpoint: `/api/v3/tracks/divergent/${trackId}`,
        })

        const response = await authorizedFetch(url)
        const doc: boolean = await response.json()

        if (typeof doc !== 'boolean') {
            reportMessage('getTrackDivergence', `getTrackDivergence failed with status code ${response.status}`)

            return createUnknownErrorResult(response.status)
        }

        return {
            status: response.status,
            type: FetchResultType.Success,
            data: doc,
        }
    } catch (error) {
        reportError('getTrackDivergence', error)

        return createUnknownErrorResult(500)
    }
}
